import $ from "jquery";

$.fn.formResetErrors = function(error) {
	$(this).find('.errors').html('');
	$(this).find('.has-error').removeClass('has-error');
	$(this).find('.errors').prop('hidden', true);
}

$.fn.formSetError = function(error) {
	$(this).find('.errors').append('<p>' + error.message + '</p>');
	for (let i in error.names) {
		$(this).find('[name="' + error.names[i] + '"]').addClass('has-error');
	}
	$(this).find('.errors').prop('hidden', false);
}

$.fn.formDisable = function() {
	$(this).find('input, textarea, select, button').prop('disabled', true);
}

$.fn.formEnable = function() {
	$(this).find('input, textarea, select, button').prop('disabled', false);
}
